// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function page1_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
 *	Adds an event handler that runs when the element is double-clicked.
 *	 @param {$w.MouseEvent} event
 */
export function page1_dblClick(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when the mouse pointer is moved
 onto the element.

> **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
 a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
 and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
 [here](https://www.wix.com/velo/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers).

 You can also [define an event handler using the Properties and Events panel](https://support.wix.com/en/article/velo-reacting-to-user-actions-using-events).
*	 @param {$w.MouseEvent} event
*/
export function page1_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when the mouse pointer is moved
 off of the element.

 > **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
 a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
 and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
 [here](https://www.wix.com/velo/forum/tips-tutorials-examples/removal-of-the-w-parameter-from-event-handlers).

 You can also [define an event handler using the Properties and Events panel](https://support.wix.com/en/article/velo-reacting-to-user-actions-using-events).
*	 @param {$w.MouseEvent} event
*/
export function page1_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when an element is displayed
 in the viewable part of the current window.
*	 @param {$w.Event} event
*/
export function page1_viewportEnter(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when an element is no longer
 displayed in the viewable part of the current window.
*	 @param {$w.Event} event
*/
export function page1_viewportLeave(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function columnStrip1_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function image1_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}